export default __webpack_public_path__ + "static/media/Animals_12.aae7688a.png";